//DEVELOPMENT MODE
export const NODE_ENV_DEVELOPMENT = "development";
export const NODE_ENV_PRODUCTION = "production";
export const DEVELOPMENT_MODE = process.env.NODE_ENV === NODE_ENV_DEVELOPMENT;

//INIT STATES
export const INIT_STATE_DATA_LOADED = 'INIT_STATE_DATA_LOADED';
export const INIT_STATE_IMAGES_PRE_LOADED = 'INIT_STATE_IMAGES_PRE_LOADED';
export const INIT_STATE_TRACKING_READY = 'INIT_STATE_TRACKING_READY';

export const TRACKING_TYPE_SCORM = 'scorm_1_2';
export const TRACKING_TYPE_XAPI = 'xapi';
export const TRACKING_TYPE_OPEN = 'open';
export const TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2 = 'scorm_1_2_xapi';
export const TRACKING_TYPE_OPEN_LEARNING = 'open_learning';

export const USER_ROLE_LEAD = "lead";
export const USER_ROLE_EDITOR = "editor";
export const USER_ROLE_REVIEWER = "reviewer";
export const USER_ROLE_VIEWER = "viewer";

export const SCREEN_STATUS_NOT_STARTED = "not_started";
export const SCREEN_STATUS_IN_PROGRESS = "in_progress";
export const SCREEN_STATUS_IN_REVIEW = "in_review";
export const SCREEN_STATUS_CHANGES = "CHANGES";
export const SCREEN_STATUS_COMPLETED = "completed";

export const DATA_PATH_TRACKING_TYPE = 'project.trackingType.constant';

export const POST_COMPLETION_MODE_REVIEW = "review";
//{process.env.NODE_ENV}




/** WEBPACK FOOTER **
 ** ./src/constants/appConstants.js
 **/